import React from 'react';
import StreamForm from './StreamForm';

const StreamCreate: React.FC = () => {
  return <StreamForm isEdit={false} />;
};

export default StreamCreate; 